<template>
  <div class="defaultBox">
    <div class="imgBox">
      <img src="./../../assets/img/defaultImg.png" alt="" />
    </div>
    <p>浙江音乐学院社会艺术考级系统</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inpModel: "",
      query: {
        total: 0,
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
      },
      tableLoad: false,
      tableList: [],
      visible: false,
    };
  },
  mounted() {
    for (let index = 0; index < 30; index++) {
      this.tableList.push({ xh: index, xsxm: "name" + index });
    }
  },
  methods: {
    inputChange(num) {
      this.$dailog({
        title: "测试",
        context: "是否删除所选内容?",
        callbackFun: () => {
          console.log(this.tableList);
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  .imgBox {
    img {
      width: 360px;
    }
    display: flex;
    justify-content: center;
  }
  p {
    text-align: center;
    font-weight: bolder;
    font-size: 30px;
    margin-top: 20px;
  }
}
</style>
